import { AbilityBuilder, createMongoAbility, subject } from "@casl/ability";
import type { AbilityRule, AppAbility } from "./types";

export { subject };

export function createAbilityFromRules(rules: AbilityRule[]): AppAbility {
  const { can, cannot, build } = new AbilityBuilder<AppAbility>(createMongoAbility);

  rules.forEach((rule) => {
    const { action, subject: target, conditions, inverted } = rule;

    if (inverted) {
      cannot(action, target, conditions);
    } else {
      can(action, target, conditions);
    }
  });

  return build();
}
